<template>
  <div class="overflow-x-auto">
    <table class="min-w-full border-collapse text-base">
      <thead>
        <tr class="border-b border-stroke bg-slate-50 text-left text-slate-600">
          <th class="px-4 py-3 font-semibold">Nome</th>
          <th class="px-4 py-3 font-semibold">Email</th>
          <th class="px-4 py-3 font-semibold">Telefone</th>
          <th class="px-4 py-3 font-semibold">Perfil</th>
          <th class="px-4 py-3 font-semibold">Recebe alertas</th>
          <th class="px-4 py-3 font-semibold">Último acesso</th>
          <th class="w-10 px-2 py-3"></th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="user in (users ?? [])"
          :key="user.id"
          class="cursor-pointer border-b border-stroke/70 text-slate-700 transition hover:bg-slate-50"
          @click="goToUserDetail(user.id)">
          <td class="px-4 py-3 font-medium text-slate-900">{{ user.name }}</td>
          <td class="px-4 py-3">{{ user.email || '-' }}</td>
          <td class="px-4 py-3">{{ user.phone_number || '-' }}</td>
          <td class="px-4 py-3">{{ translateRole(user.role) }}</td>
          <td class="px-4 py-3">{{ user.receive_alerts ? 'Sim' : 'Não' }}</td>
          <td class="px-4 py-3">{{ formatLastAccess(user.last_sign_in_at) }}</td>
          <td class="px-2 py-3 text-slate-400">→</td>
        </tr>
      </tbody>
    </table>
    <div
      v-if="!users?.length"
      class="border border-dashed border-stroke p-8 text-center text-base text-slate-500">
      Nenhum usuário encontrado nesta empresa.
    </div>
  </div>
</template>

<script setup lang="ts">
import type { ICompanyUser } from '@/interfaces/entities/user'
import { translateUserRole } from '@/interfaces/enums'
import { useRouter } from 'vue-router'

const props = defineProps<{
  users?: ICompanyUser[] | null
  companyId?: number | null
}>()

const router = useRouter()

const translateRole = (role?: string) => translateUserRole(role)

const formatLastAccess = (date?: string | null) => {
  if (!date) return 'Sem acesso'
  const d = new Date(date)
  const now = new Date()
  const diffDays = Math.floor((now.getTime() - d.getTime()) / (1000 * 60 * 60 * 24))
  if (diffDays === 0) return d.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })
  if (diffDays === 1) return 'Ontem'
  if (diffDays < 7) return `${diffDays} dias atrás`
  return d.toLocaleDateString('pt-BR')
}

const goToUserDetail = (userId: number) => {
  const companyId = props.companyId
  if (companyId) {
    router.push({
      name: 'company-user-detail',
      params: { profileCompanyId: String(companyId), userId: String(userId) },
    })
  }
}
</script>
